export default {
    calculations: [],
    calculationsLoading: false,
    calculation: {},
    calculationPrintColors: [],
    calculationStatusList: [],
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters,
}

function setInitialFilters() {
    return {
        name: null,
        customerName : null
    }
}